<template>
  <v-dialog v-model="dialog.display" max-width="450" persistent>
    <v-card>
      <v-card-title>
        <span class="text-subtitle-2">
          <span class="font-weight-bold secondary-font">{{
            $t("users.mynetwork.connect.title")
          }}</span>
        </span>
      </v-card-title>
      <v-divider></v-divider>

      <!-- Step 1: Init connection -->
      <template v-if="step === 1">
        <v-card-text class="px-5 py-5">
          <v-select
            v-model="factorChannel"
            :items="factorChannelOptions"
            :label="$t('users.mynetwork.connect.factor_channel')"
            append-icon="mdi-shield-check-outline"
            dense
            item-text="text"
            item-value="value"
          ></v-select>
        </v-card-text>
        <v-card-actions class="px-5 pb-4">
          <v-spacer></v-spacer>
          <v-btn text @click="cancel()" :disabled="loading">{{
            $t("btn.cancel")
          }}</v-btn>
          <v-btn
            color="primary"
            @click="initConnection()"
            :loading="loading"
            :disabled="!factorChannel"
            >{{ $t("btn.next") }}</v-btn
          >
        </v-card-actions>
      </template>

      <!-- Step 2: Confirm connection -->
      <template v-if="step === 2">
        <v-card-text class="px-5 py-5">
          <v-alert type="info" dense text class="mb-4">
            {{ $t("users.mynetwork.connect.mfa_sent") }}
          </v-alert>
          <v-text-field
            v-model="mfaCode"
            :label="$t('users.mynetwork.connect.mfa_code')"
            append-icon="mdi-shield-key-outline"
            dense
            autofocus
            maxlength="10"
            @keyup.enter="confirmConnection()"
          ></v-text-field>
        </v-card-text>
        <v-card-actions class="px-5 pb-4">
          <v-btn text @click="goBack()" :disabled="loading">{{
            $t("btn.previous")
          }}</v-btn>
          <v-spacer></v-spacer>
          <v-btn text @click="cancel()" :disabled="loading">{{
            $t("btn.cancel")
          }}</v-btn>
          <v-btn
            color="primary"
            @click="confirmConnection()"
            :loading="loading"
            :disabled="!mfaCode"
            >{{ $t("btn.confirm") }}</v-btn
          >
        </v-card-actions>
      </template>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions } from "vuex";

export default {
  props: {
    dialog: {
      type: Object,
      default: function () {
        return {
          display: false,
        };
      },
    },
    user: {
      type: Object,
      default: function () {
        return {};
      },
    },
  },
  data: () => ({
    step: 1,
    factorChannel: "email",
    mfaCode: "",
    loading: false,
    factorChannelOptions: [
      { text: "Email", value: "email" },
      { text: "Google Authenticator", value: "google" },
    ],
  }),
  watch: {
    "dialog.display"(newVal) {
      if (newVal) {
        this.reset();
      }
    },
  },
  methods: {
    reset() {
      this.step = 1;
      this.factorChannel = "email";
      this.mfaCode = "";
      this.loading = false;
    },
    cancel() {
      this.dialog.display = false;
      this.reset();
    },
    goBack() {
      this.step = 1;
      this.mfaCode = "";
    },
    async initConnection() {
      if (!this.factorChannel) return;

      this.loading = true;
      try {
        const response = await this.request({
          url: "/api/mynetwork/connect-init",
          method: "POST",
          data: {
            identifier: this.user?.mynetwork?.identifier,
            factorChannel: this.factorChannel,
          },
        });

        if (response.data?.status === true) {
          this.step = 2;
        } else {
          const description = response.data?.description;
          if (description) {
            this.notify({ message: description });
          } else {
            this.notify({ message: this.$t("users.mynetwork.connect.error") });
          }
        }
      } catch (error) {
        const description = error?.response?.data?.description;
        if (description) {
          this.notify({ message: description });
        } else {
          this.notify({ message: this.$t("users.mynetwork.connect.error") });
        }
      }
      this.loading = false;
    },
    async confirmConnection() {
      if (!this.mfaCode) return;

      this.loading = true;
      try {
        const response = await this.request({
          url: "/api/mynetwork/connect-confirm",
          method: "POST",
          data: {
            identifier: this.user?.mynetwork?.identifier,
            mfaCode: this.mfaCode,
          },
        });

        if (response.data?.status === true) {
          this.notify({ message: this.$t("users.mynetwork.connect.success") });
          this.dialog.display = false;
          this.reset();
          this.$emit("success");
        } else {
          const description = response.data?.description;
          if (description) {
            this.notify({ message: description });
          } else {
            this.notify({ message: this.$t("users.mynetwork.connect.error") });
          }
        }
      } catch (error) {
        const description = error?.response?.data?.description;
        if (description) {
          this.notify({ message: description });
        } else {
          this.notify({ message: this.$t("users.mynetwork.connect.error") });
        }
      }
      this.loading = false;
    },
    ...mapActions({ request: "request", notify: "notification/notify" }),
  },
};
</script>
